export default __webpack_public_path__ + "static/joko-app-screenshot-home-1-en-7ab19fbfc0b352e04a676db21159bd1f.webp";